// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footerContainer":"Footer_footerContainer__WPMg8","footerText":"Footer_footerText__n14sU"};